import '../resources/css/magazine.css';
import Button from './shared/Button';
import Separator from './shared/Separator';

export default function Magazine({ data }) {

    const { title, background, posts } = data;

    const renderedPosts = (posts || []).map((post) => {
        return <div className="magazine-item" key={post.id}>

            {post.image && <img src={post.image} alt="welcome"></img>}

            {post.title && <div className="title-h2 color-purple">{post.title}</div>}

            {post.secondTitle && <p className="magazine-item-title">{post.secondTitle}</p>}

            {post.text && <p>{post.text}</p>}

            {post.button && <Button href={post.button.url}>{post.button.text}</Button>}

        </div>
    });

    return (
        <div >
            <div className="magazine" style={{ backgroundImage: `url(${background})` }}>

                <div className="title-h1 color-purple">{title}</div>

                <Separator className="color-purple"></Separator>

                <div className="magazine-content">
                    {renderedPosts}
                </div>

            </div>

        </div >);
};